import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, PersonSelect, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAAgentDetails() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  
  useScrollToTop();
  
  const numberOfAgents = powerOfAttorney.number_of_agents || 1;
  const [ agents, setAgents ] = useState(
    powerOfAttorney.agents || Array(numberOfAgents).fill(null).map(() => ({
      name: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      alt_phone: '',
      email: ''
    }))
  );

  const handleClickableOption = useCallback(() => {
    console.log('clicked');
  }, []);

  const handleChange = useCallback((option: any) => {
    console.log('changed', option);
  }, []);

  const handleBack = useCallback(() => {
    navigate('../number-agents');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      agents: agents
    }));
    navigate('../alternate-agent');
  }, [ agents, setPowerOfAttorney, navigate ]);

  const options = [];
  
  return (
    <div className="new-poa-agent-details screen-container">
      <ScreenHeader
        title="Agent Details"
        description={`Provide complete contact information for your ${numberOfAgents} agent${numberOfAgents > 1 ? 's' : ''}`}
        handleBack={handleBack}      
      />

      <PersonSelect
        id="primary-beneficiary"
        handleClickableOption={handleClickableOption}
        handleSelect={handleChange}
        options={options}
        selected={null}
      />
    
      <div className="important-note">
        <h4>Important:</h4>
        <p>
          Make sure all contact information is current and accurate. Your agent will need to 
          be reachable when important financial decisions need to be made.
        </p>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
